import React from 'react';
import { T } from 'shared/helper/translate';
var DigitalTranslationsInstructions = function DigitalTranslationsInstructions(_ref) {
  var accessType = _ref.accessType;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-instructions-".concat(accessType)
  })));
};
export default DigitalTranslationsInstructions;